import { render, staticRenderFns } from "./providers-table.vue?vue&type=template&id=1618be7a&scoped=true"
import script from "./providers-table.vue?vue&type=script&lang=js"
export * from "./providers-table.vue?vue&type=script&lang=js"
import style0 from "./providers-table.vue?vue&type=style&index=0&id=1618be7a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1618be7a",
  null
  
)

export default component.exports